import { jsxs as l, Fragment as C, jsx as e } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ l(C, { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.25 1.25C9.99484 1.25 8.16667 3.07817 8.16667 5.33333V12.9517C7.13724 13.9901 6.5 15.421 6.5 17C6.5 20.1756 9.07436 22.75 12.25 22.75C15.4256 22.75 18 20.1756 18 17C18 15.421 17.3628 13.9901 16.3333 12.9517V5.33333C16.3333 3.07817 14.5052 1.25 12.25 1.25ZM12.25 6.19092C12.6968 6.19092 13.0591 6.55316 13.0591 7L13.0591 14.0165C14.239 14.3652 15.1 15.457 15.1 16.75C15.1 18.324 13.824 19.6 12.25 19.6C10.676 19.6 9.40002 18.324 9.40002 16.75C9.40002 15.457 10.261 14.3652 11.4409 14.0165L11.4409 7C11.4409 6.55316 11.8032 6.19092 12.25 6.19092Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.25 15.4C11.5044 15.4 10.9 16.0044 10.9 16.75C10.9 17.4956 11.5044 18.1 12.25 18.1C12.9956 18.1 13.6 17.4956 13.6 16.75C13.6 16.0044 12.9956 15.4 12.25 15.4Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
